import LoginForm from "@/components/auth/LoginForm";
import React from "react";
import LandingPageImage from "../../assets/images/banner-plan.jpg";
interface Props {
  children: React.ReactNode;
}
function LandingPageWrapper({ children }: Props) {
  return (
    <div className="flex flex-col md:flex-row w-screen h-screen justify-center md:justfiy-between">
      <div className="hidden md:flex flex-1">
        <img
          src={LandingPageImage}
          alt="Landing Page"
          className="object-cover w-full h-full"
        />
      </div>

      <div className="flex justify-center items-center w-full md:w-1/2 p-4">
        <div className="w-full max-w-md">{children}</div>
      </div>
    </div>
  );
}

export default LandingPageWrapper;
